/**
 * 学習進捗の絞り込みに使用する定数定義
 */
export namespace ProgressFilter {
  // 全て
  export const ALL: ProgressFilterMaster = {
    code: 'all',
    label: 'すべて',
  }

  // 未学習
  export const NOT_YET: ProgressFilterMaster = {
    code: 'notyet',
    label: '未学習',
  }

  // 進行中
  export const LEARNING: ProgressFilterMaster = {
    code: 'learning',
    label: '進行中',
  }

  // 学習済み
  export const COMPLETE: ProgressFilterMaster = {
    code: 'complete',
    label: '学習済み',
  }

  // 学習進捗一覧
  export const LIST: ProgressFilterMaster[] = [
    ProgressFilter.ALL,
    ProgressFilter.NOT_YET,
    ProgressFilter.LEARNING,
    ProgressFilter.COMPLETE,
  ]

  /**
   * codeの値から該当する定数を見つけて返す
   *
   * @param code 学習進捗のcode
   * @returns 学習進捗の定数
   */
  export function findByCode(code: string): ProgressFilterMaster | undefined {
    return ProgressFilter.LIST.find((status) => {
      return status.code === code
    })
  }

  /**
   * 学習進捗のマスタ定義
   */
  export type ProgressFilterMaster = {
    /** コード */
    code: string
    /** ラベル */
    label: string
  }
}
